// extracted by mini-css-extract-plugin
export var chevronIcon = "_9f-2";
export var teamName = "_9f-1";
export var teamSwitcherButton = "_9f-0";